<template>
    <div class="mt-6">
        <b-row>
            <b-col col lg="6">
                <b-card>
                    <b-row class="d-flex justify-content-between">
                        <div role="group" class="form-group text-label" style="float: left; width: 100%;">
                            <b-row>
                                <div class="col-3">
                                    <label style="font-weight: bold;font-size: 15px" id="forma-pagamento">
                                        Forma de Pagamento:
                                    </label>
                                </div>
                                <div class="col-5">
                                    <b-form-checkbox-group v-model="formaPagamento" name="radio-formaPagamento">
                                        <b-row style="font-size: 15px">
                                            <b-form-checkbox @change="check()" value=1> Boleto FEPGE </b-form-checkbox>
                                            <b-form-checkbox @change="check()" value=2>Transf. FEPGE </b-form-checkbox>
                                        </b-row>
                                    </b-form-checkbox-group>
                                </div>
                                <div class="col-4">
                                    <b-button class="ml-2" variant="outline-success" @click="exportarCSVFinanceiro"
                                        :disabled="!obrigatorios || !podePesquisar" style="font-size: 15px">
                                        <i class="fa fa-table"></i> Exportar CSV
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-row>
                    <b-row class="d-flex justify-content-between mt-4">
                        <div role="group" class="form-group text-label" style="float: left;">
                            <b-row class="mb-4">
                                <div class="col-3">
                                    <label style="font-weight: bold;font-size: 15px" id="formaPagamento">
                                        Geração (por período):
                                    </label>
                                </div>
                                <div class="col-7">
                                    <b-form-group>
                                        <b-row>
                                            <div class="mx-1">
                                                <vue-monthly-picker
                                                    @selected="check"
                                                    v-model="dataMonitoramentoInicial"
                                                    dateFormat="MM/YYYY"
                                                    :monthLabels="monthlyLabels"
                                                    id="dataInicio" :max="maxDate" name="dataInicio" 
                                                    :class="!validations.dataInicio.valid || !validations.dataInicio.pastDate || validations.dataInicio.greaterThan ? 'is-invalid' : ''">
                                                </vue-monthly-picker>   
                                            </div>
                                            <div class="mx-1">
                                                <vue-monthly-picker
                                                    v-model="dataMonitoramentoFinal"
                                                    dateFormat="MM/YYYY"
                                                    :monthLabels="monthlyLabels"
                                                    @selected="check"
                                                    :class="!validations.dataFim.valid || !validations.dataFim.pastDate ? 'is-invalid' : ''"
                                                    id="dataFim" :min="dataMinima" name="dataFim">
                                                </vue-monthly-picker>  
                                            </div>
                                        </b-row>
                                        <div v-if="!validations.dataInicio.valid" class="invalid-message">A data inserida é
                                            inválida!</div>
                                        <div v-if="!validations.dataInicio.pastDate" class="invalid-message">A data inserida
                                            é
                                            maior que a data atual.</div>
                                        <div v-if="validations.dataInicio.greaterThan" class="invalid-message">A data
                                            inicial é
                                            maior que a data final.</div>
                                        <div v-if="!validations.dataFim.valid" class="invalid-message">A data inserida é
                                            inválida!</div>
                                        <div v-if="!validations.dataFim.pastDate" class="invalid-message">A data inserida é
                                            maior que a data atual.</div>
                                    </b-form-group>
                                </div>
                                <div class="col-1">
                                    <b-button @click="consultar" variant="primary"
                                        :disabled="!obrigatorios || !podePesquisar">
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-row>
                    <b-row class="d-flex justify-content-between text-label" v-if="podeRenderizar">

                        <table style="width:100%" class="espaco-celula">
                            <caption style="color:transparent">Tabela com resultados das receitas realizadas e frustradas
                            </caption>
                            <thead>
                                <tr>
                                    <th id="emBranco1"></th>
                                    <th id="realizada" colspan="2" style="font-weight: bold;"
                                        class="realizadas text-center">
                                        Receita Realizada
                                    </th>
                                    <th id="frustradas" colspan="2" style="font-weight: bold;"
                                        class="frustradas text-center">
                                        Receita Frustada
                                    </th>
                                </tr>
                                <tr>
                                    <th id="emBranco2"></th>
                                    <th id="qtdRealizadas" class="text-center">Qtde</th>
                                    <th id="valorRealizadas" class="text-center">Valor</th>
                                    <th id="qtdFrustradas" class="text-center">Qtde</th>
                                    <th id="valorFrustradas" class="text-center">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in receitas" :key="item.descricao">
                                    <td>{{ item.descricao }}:</td>
                                    <td class="border text-center realizadas p-2 rounded">
                                        {{ item.qtdRealizado }}
                                    </td>
                                    <td class="border text-right realizadas rounded">
                                        R$ {{ item.valorRealizado | currency }}
                                    </td>
                                    <td class="border text-center frustradas rounded">
                                        {{ item.qtdFrustrada }}
                                    </td>
                                    <td class="border text-right frustradas rounded">
                                        R$ {{ item.valorFrustrado | currency }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr style="font-weight: bold;">
                                    <td>Total Geral</td>
                                    <td class="border text-center realizadas rounded">
                                        {{ this.qtdRealizadoTotal }}
                                    </td>
                                    <td class="border text-right realizadas rounded">
                                        R$ {{ this.valorRealizadoTotal | currency }}
                                    </td>
                                    <td class="border text-center frustradas rounded">
                                        {{ this.qtdFrustradaTotal }}
                                    </td>
                                    <td class="border text-right frustradas rounded">
                                        R$ {{ this.valorFrustadoGeral | currency }}
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </b-row>
                    <b-row class="d-flex justify-content-between text-label mt-3" v-if="podeRenderizar">
                        <b-col cols="8">
                            <table style="width:100%" class="espaco-celula" id="receitasNaoRealizadas">
                                <caption style="color:transparent">Tabela com resultados das receitas não realizadas
                                </caption>
                                <thead>
                                    <tr>
                                        <th id="naoRealizada" colspan="3" style="font-weight: bold;"
                                            class="nao-realizada text-center">
                                            Receita Não Realizada
                                        </th>
                                    </tr>
                                    <tr>
                                        <th id="emBranco"></th>
                                        <th id="qtd">Qtde</th>
                                        <th id="valor">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in receitasNaoRealizadas" :key="item.quantidade">
                                        <td style="font-weight: bold">Total: </td>
                                        <td class="border text-center rounded nao-realizada p-2">
                                            {{ item.quantidade }}
                                        </td>
                                        <td class="border text-center rounded nao-realizada p-2">
                                            R$ {{ item.valor | currency }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                        <b-col cols="4">
                            <table style="width:100%" class="espaco-celula" id="totalBoletoTransferencia">
                                <caption style="color:transparent">Tabela com resultado totais por boleto e transferência
                                </caption>
                                <thead>
                                    <tr>
                                        <th colspan="3" style="font-weight: bold;" class="total text-center">
                                            Total
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="font-weight: bold;">
                                        <th>Boletos:</th>
                                        <td class="border text-center rounded p-2">
                                            {{ this.quantidadeBoleto }}
                                        </td>
                                    </tr>
                                    <tr style="font-weight: bold;">
                                        <th>Transf.:</th>
                                        <td class="border text-center rounded p-2">
                                            {{ this.quantidadeTransferencia }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>

                </b-card>
            </b-col>
            <b-col col lg="6">
                <b-card>
                    <div class="ml-2">
                        <b-form-group id="radioGraficoRequisicaoForm">
                            <b-form-radio-group
                                id="radioGraficoFinanceiro"
                                v-model="selecionado"
                                :options="options"
                                name="graficoRadio"
                                :checked="selecionado"
                                @change="criarGraficoSelecionado($event)" />
                        </b-form-group>
                    </div>
                    <div class="ml-2">
                        <div id="grafico1"></div>
                    </div>

                </b-card>
            </b-col>
        </b-row>
        <CompLoading ref="loading"></CompLoading>
    </div>
</template>

<script>
import axios from 'axios';
import formatarMixins from '../../../mixins/formatarMixins';
import ApexCharts from 'apexcharts'
import CompLoading from "../../shared/components/CompLoading";
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'

export default {
    props: ['loading'],
    components: { CompLoading, VueMonthlyPicker },
    mixins: [formatarMixins],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        },
        dataMonitoramentoInicial() {
            if (this.dataMonitoramentoInicial) {
                this.dataInicio = moment(this.dataMonitoramentoInicial, 'YYYY-MM-dd').format();
            } else {
                this.dataInicio = null;
            }
        },
        dataMonitoramentoFinal() {
            if (this.dataMonitoramentoFinal) {
                this.dataFim = moment(this.dataMonitoramentoFinal).format('YYYY-MM-') 
                             + moment(this.dataMonitoramentoFinal).endOf('month').date();
            } else {
                this.dataFim = null;
            }
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            maxDate: null,
            formaPagamento: [],
            dataInicio: null,
            dataFim: null,
            controleGrafico: false,
            itemsFinanceiro: [],
            receitas: [],
            totais: [],
            receitasNaoRealizadas: [],
            graficos: [],
            validations: {
                dataInicio: { valid: true, pastDate: true, greaterThan: false },
                dataFim: { valid: true, pastDate: true, lessThan: false }
            },
            qtdFrustradaTotal: 0,
            qtdRealizadoTotal: 0,
            valorFrustadoGeral: 0,
            valorRealizadoTotal: 0,
            qtdFrustrada: [],
            qtdRealizado: [],
            datas: [],
            valorFrustradas:[],
            valorRealizadas:[],
            chartInstance: null,
            quantidadeBoleto: 0,
            quantidadeTransferencia: 0,
            load: false,
            podeRenderizar: false,
            podePesquisar: false,
            selecionado: 1,
            options:[
                { text: 'Quantidade', value: 1 },
                { text: 'Valor', value: 2 }
            ],
            monthlyLabels: [
                'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez' 
            ],
            dataMonitoramentoInicial: null,
            dataMonitoramentoFinal: null,
            obrigatorios: false
        }
    },
    computed: {
        getTheme() {
            return this.$store.getters.getTheme
        },
        dataMinima() {
            let minDate = null;
            if (this.dataInicio) {
                moment(this.dataInicio).isBefore(this.dataFim);
                minDate = moment(this.dataInicio)
            }
            return minDate;
        }
    },
    methods: {
        check() {
            this.$nextTick(() => {
                this.obrigatorios = this.formaPagamento.length > 0 && this.dataInicio && this.dataFim;
                this.verificarDataInicioEFim();
            });
        },

        verificarDataInicioEFim() {
            if (this.dataInicio && this.dataFim) {
                if (this.dataInicio > this.dataFim) {
                    this.validations.dataInicio.greaterThan = true;
                    this.podePesquisar = false;
                } else {
                    this.validations.dataInicio.greaterThan = false;
                    this.podePesquisar = true;
                }
            } else {
                this.validations.dataInicio.greaterThan = false;
                this.podePesquisar = false;
            }
        },

        criarGraficoSelecionado(selecionado){
            this.selecionado = selecionado;
            if (this.chartInstance !== null) {
                    this.chartInstance.destroy();
            }
            if(selecionado == 1){
                this.createChart(this.qtdFrustrada, this.qtdRealizado, this.datas);
            } else {
                this.createChart(this.valorFrustradas, this.valorRealizadas, this.datas);
            }
            
        },
        createChart(qtdFrustrada, qtdRealizado, datas) {
            const options = {
                series: [
                    {
                        name: 'Realizada',
                        data: qtdRealizado
                    },
                    {
                        name: 'Frustrada',
                        data: qtdFrustrada
                    }
                ],
                chart: {
                    id: 'grafico1',
                    type: 'bar',
                    stacked: true
                },
                xaxis: {
                    categories: datas,
                    tickPlacement: true
                },
                colors: ['#008EF9', '#FC4257'],
                plotOptions: {
                    bar: {
                        borderRadius: 5,
                        horizontal: false,
                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter: (val) => {
                        return this.formatarValorMonetarioNovo(val); 
                    },
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                legend: {
                    position: 'right',
                    inverseOrder: true
                },
            };
            this.chartInstance = new ApexCharts(document.querySelector("#grafico1"), options);
            this.chartInstance.render();
        },
        formatarValorMonetarioNovo(valor) {
            let novoValor = valor;
            if(this.selecionado !== 1){
                if(valor !== null){
                    valor = valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                    });     
                }
                novoValor = valor.replace("R$", "")
            }
            return novoValor;
        },
        async consultar() {
            this.podeRenderizar = false;
            this.selecionado = 1;

            this.$refs.loading.showLoading();
            let body = {
                formaPagamento: this.formaPagamento,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim
            }
            axios.post(`${this.urlApi}/v1/painelTesoureiro/consultarFinanceiro`, body, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemsFinanceiro = response.data;
                this.receitas = this.itemsFinanceiro.receitas;
                this.receitasNaoRealizadas = [this.itemsFinanceiro.receitasNaoRealizadas];
                this.totais = (this.itemsFinanceiro.totais);
                this.graficos = this.itemsFinanceiro.grafico;

                this.quantidadeBoleto = this.totais.quantidadeBoleto;
                this.quantidadeTransferencia = this.totais.quantidadeTransferencia;

                this.datas = this.graficos.map(x => { return x.rotulo })
                this.qtdFrustrada = this.graficos.map(x => { return x.quantidadeFrustradaOuParcelada })
                this.qtdRealizado = this.graficos.map(x => { return x.quantidadeRealizadaAVista })
                this.valorRealizadas = this.graficos.map(x => { return x.valorRealizadaAVista })
                this.valorFrustradas = this.graficos.map(x => { return x.valorFrustradaOuParcelada })

                let sumFrustrado = 0;
                let sumRealizados = 0;
                let sumValor1 = 0;
                let sumValor2 = 0;
                this.receitas.forEach(num => {
                    sumFrustrado += num.qtdFrustrada;
                    sumRealizados += num.qtdRealizado;
                    sumValor1 += num.valorFrustrado
                    sumValor2 += num.valorRealizado
                });
                this.qtdFrustradaTotal = sumFrustrado;
                this.qtdRealizadoTotal = sumRealizados;
                this.valorFrustadoGeral = sumValor1;
                this.valorRealizadoTotal = sumValor2;

                if (this.chartInstance !== null) {
                    this.chartInstance.destroy();
                }
                this.criarGraficoSelecionado(this.selecionado);
                this.podeRenderizar = true;
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.$refs.loading.hideLoading();
            })
        },
        async exportarCSVFinanceiro() {
            this.load = true;
            this.$refs.loading.showLoading();

            let filtroRequisicao = {
                formaPagamento: this.formaPagamento,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim

            };

            axios.post(`${this.urlApi}/v1/painelTesoureiro/exportarCsvFinanceiro`, filtroRequisicao, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'PainelTesoureiroFinanceiro.csv');
                    document.body.appendChild(link);
                    link.click();
                }).finally(() => {
                    this.load = false;
                    this.$refs.loading.hideLoading();
                })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        
        let dataAtual = new Date();
        let ano = dataAtual.getFullYear();
        let mes = dataAtual.getMonth() + 1;
        this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dataAtual.getDate() < 10 ? "0" : "") + dataAtual.getDate();

    }

}
</script>

<style scoped>
.realizadas {
    color: #3399FF;
}

.frustradas {
    color: #F44336;
}

.nao-realizada {
    color: #ffa500;
}

.espaco-celula {
    border-collapse: separate;
    border-spacing: 10px;
}
</style>
